import { periodFormat } from 'utils/common';

export const devicesReq = (filter, customerId) => {
  const REQ_BODY = {
    filters: {
      customerId: customerId,
      search: filter.search ? filter.search : '*',
      deviceType: filter.deviceType[0] ? filter.deviceType : '*',
      os: filter.os[0] ? filter.os : '*',
      osVersion: filter.osVersion[0] ? filter.osVersion : '*',
      appVersion: filter.appVersion[0] ? filter.appVersion : '*',
      timezone: filter.timezone[0] ? filter.timezone : '*',
      role: filter.role[0] ? filter.role : '*',
      groups: filter.groups[0] ? filter.groups : '*',
      lastDeviceLogin: periodFormat(filter.lastDeviceLogin),
      idp: filter.idp[0] ? filter.idp : '*',
      postureCheckStatus: filter.postureCheckStatus[0]
        ? filter.postureCheckStatus
        : '*',
      lastPostureCheckAt: periodFormat(filter.lastPostureCheckAt),
      'attachedPolicy.profileName': filter.attachedPolicy[0]
        ? filter.attachedPolicy
        : '*'
    },
    sort: {
      fieldName: filter.fieldName,
      direction: filter.direction
    }
  };
  return REQ_BODY;
};
